module.exports = __webpack_public_path__ + "img/build-img.cd95a4bd.png";